@if (!isStepTableLoading) {
<div animate.enter="enter-animation">
  <div class="otsc-prop-header">
    @if (mode == PlansFormMode.ADD) {
    <h1 class="otsc-prop-header-text" i18n>New plan</h1>
    }
    @if (mode == PlansFormMode.EDIT) {
    <h1 class="otsc-prop-header-text" i18n>Edit plan - {{plan?.name}}</h1>
    }
  </div>
  <div class="init-container" [hidden]="detailState !== PlansDetailsState.INIT">
    <ng-scrollbar>
      <div class="ot-section ot-p-0">
        <div class="ot-panel">
          @if (plan) {
          <div style="width:33%" class="ot-panel__body ot-pt-1 ot-pl-1 ot-pr-1 ot-pb-0">
            <app-plans-form [mode]="mode" [plan]="plan" (formEvent)="updateForm($event)"
              [height]="'257px'"></app-plans-form>
          </div>
          }
          @if (formGroup) {
          <div>
            <div class="ot-btn-group ot-pl-1"
              [ngClass]="{'ot-pt-1': formGroup.get('nameCtrl').touched && formGroup.get('nameCtrl').errors && (formGroup.get('nameCtrl').errors.required || formGroup.get('nameCtrl').errors.plannameExists)}">
              <button id="otsc-plan-execute-btn" role="button" title="Execute this plan" i18n-title
                class="ot-btn ot-btn--is-primary ot-icon ot-icon--is-24x24"
                (click)="save(PlanSaveState.SAVE_AND_EXECUTE)"
                [disabled]="formGroup.pending || formGroup.invalid || plan.steps.length == 0 || plan.selectedEnvironmentId != solutionInfo.currentEnvironment.id || hasStepsWithError() || buttonPending">
                <svg style="padding-right: 5px" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24"
                  width="24px" fill="#FFFFFF">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z" />
                </svg>
                Execute
              </button>
              <button id="otsc-plan-save-btn" role="button" title="Save this plan" i18n-title
                class="ot-btn ot-btn--is-primary ot-icon ot-icon--is-24x24" (click)="save(PlanSaveState.SAVE_PLAN)"
                [disabled]="formGroup.pending || formGroup.invalid || plan.steps.length == 0 || buttonPending">
                <svg style="padding-right: 5px" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24"
                  width="24px" fill="#FFFFFF">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
                </svg>
                Save
              </button>
              <button id="otsc-plan-close-btn" role="button" title="Close" i18n-title
                class="ot-btn ot-btn--is-secondary ot-icon ot-icon--is-24x24" (click)="close()"
                [disabled]="buttonPending">
                <svg style="padding-right: 5px" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24"
                  width="24px" fill="#333">
                  <path d="M0 0h24v24H0z" fill="none" />
                  <path
                    d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                </svg>
                Close
              </button>
            </div>
          </div>
          }
        </div>
      </div>
      <div class="ot-section ot-p-0">
        <div class="ot-level" style="border-bottom: 1px solid #cccccc;">
          <div class="ot-level__left" style="max-width: 100%">
            <div class="ot-dropdown" style="margin-left: 15px;margin-right: 15px">
              <button id="otsc-plan-add-step-btn" title="Add steps" i18n-title role="button"
                class="ot-btn ot-btn--is-transparent" style="min-width: unset;padding:0px;" (click)="onAddItemClick()">
                <i class="ot-add"></i>
              </button>
            </div>
            <app-tabs [identifier]="'plan-details-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="tabs"
              [color]="TabColor.PRIMARY" [border]="false" [selectedIndex]="activeTab"></app-tabs>
          </div>
        </div>
        @if (activeTab === PlanDetailsTab.STEPS) {
        <div>
          <app-datatable [identifier]="'otsc-plans-details-step-table'" [showcheckboxes]="true"
            [isDragAndDropEnabled]="true" (onDrop)="drop($event)" [scroll]="false" [isHoverable]="false"
            [rowDensity]="stepRowDensity" [cols]="stepCols" [rows]="stepRows" [isloading]="isStepTableLoading"
            (actionmenuevent)="actionMenuClicked($event)" (onDropDownChange)="stepSysVarChanged($event)"
            [recountSelectedRow]="recountSelectedRowStepsTable"></app-datatable>
        </div>
        }
        @if (activeTab === PlanDetailsTab.VARIABLES) {
        <div class="ot-panel__body">
          <div class="ot-p-1">
            @if (this.plan.variables.length > 0) {
            @for (planVar of this.plan.variables | orderBy:'asc':'name' ; track planVar; let i = $index) {
            <div class="ot-row">
              <div class="ot-col ot-row__column ot-row__column--is-33">
                <div class="ot-form-control ot-mb-0">
                  <label class="ot-form-control__label" [for]="'varCtrl-' + i">
                    {{planVar.name}}
                  </label>
                  @if (planVar.type === 'INT') {
                  <input [id]="'varCtrl-' + i" type="number" class="ot-input" [(ngModel)]="planVar.value"
                    (ngModelChange)="onVarValChanged(planVar)">
                  }
                  @if (planVar.type === 'STRING') {
                  <input [id]="'varCtrl-' + i" type="text" class="ot-input" [(ngModel)]="planVar.value"
                    (ngModelChange)="onVarValChanged(planVar)" [disabled]="planVar.sensitive">
                  }
                  @if (planVar.type === 'TEXTAREA') {
                  <textarea [id]="'varCtrl-' + i" class="ot-textarea" rows="2" [(ngModel)]="planVar.value"
                    (ngModelChange)="onVarValChanged(planVar)" [disabled]="planVar.sensitive"></textarea>
                  }
                  @if (planVar.type === 'BOOLEAN') {
                  <app-checkbox [identifier]="'varCtrl-' + i" [(ngModel)]="planVar.value"
                    (ngModelChange)="onVarValChanged(planVar)" i18n-label [label]="planVar.name" i18n-arialabel
                    [arialabel]="planVar.name">
                  </app-checkbox>
                  }
                  @if (planVar.type === 'LIST') {
                  <div class="ot-select">
                    <select [id]="'varCtrl-' + i" [(ngModel)]="planVar.value" (change)="onVarValChanged(planVar)">
                      @for (option of planVar.parameter.defaultListValue; track option) {
                      <option [value]="option.value">
                        {{option.name}}
                      </option>
                      }
                    </select>
                  </div>
                  }
                  @if (planVar.type === 'EXT_FILE') {
                  <app-ext-ven-files-typeahead [identifier]="'varCtrl-' + i"
                    [selectedExtVenderFileName]="getExtVenFileVal(planVar.value)"
                    [constraints]="planVar.parameter.constraints"
                    (onSelectFile)="onExtVenFileSelect($event, planVar.parameter)"
                    (onDeselectFile)="onExtVenFileDeselect(planVar.parameter)"></app-ext-ven-files-typeahead>
                  }
                  @if (planVar.type === 'PRODUCT_FILE') {
                  <app-prod-files-typeahead [identifier]="'varCtrl-' + i"
                    [selectedProdFileName]="planVar.value ? planVar.value.name : undefined"
                    [constraints]="planVar.parameter.constraints"
                    (onSelectFile)="onProdFileSelect($event, planVar.parameter)"
                    (onDeselectFile)="onProdFileDeselect(planVar.parameter)"></app-prod-files-typeahead>
                  }
                </div>
              </div>
              <div class="ot-col ot-row__column ot-row__column--is-10">
                <div role="group" class="ot-btn-group ot-pt-1 ot-pl-2 ot-mb-0">
                  <button class="ot-btn ot-icon ot-icon--is-action-icon ot-p-0" (click)="onRemoveVarBtnClick(planVar)"
                    title="Remove" title-i18n>
                    <span class="otsc-variable-delete"></span>
                  </button>
                </div>
              </div>
              @if (planVar.type === 'STRING' || planVar.type === 'TEXTAREA') {
              <div class="ot-col ot-row__column ot-row__column--is-10">
                <div role="group" class="ot-btn-group ot-pt-2 ot-pl-2 ot-mb-0">
                  <app-checkbox [identifier]="'varCtrl-sensitive-' + i" [(ngModel)]="planVar.sensitive"
                    (ngModelChange)="onSetVariableSensitiveClick(planVar)" i18n-label [label]="'Sensitive'"
                    i18n-arialabel [arialabel]="'Password'">
                  </app-checkbox>
                </div>
              </div>
              }
            </div>
            }
            } @else {
            <div class="ot-table--is-center">
              <img alt-i18n alt="There are no variables assigned." src="./assets/icons/es_list220.svg">
              <p i18n>There are no variables assigned.</p>
            </div>
            }
          </div>
        </div>
        }
        @if (activeTab === PlanDetailsTab.SYSTEM_VARIABLES) {
        <div>
          <app-datatable [identifier]="'otsc-plans-details-systemVar-table'" [showInline]="false"
            [showcheckboxes]="true" [title]="''" [scroll]="false" [rowDensity]="stepRowDensity" [cols]="systemVarCols"
            [rows]="systemVarRows" [showaddicon]="true" [overrideShowError]="true"
            (onclickheaderadd)="addNewSystemVariableRow()" (actionmenuevent)="systemVariablesActionMenuClicked($event)"
            (onDropDownChange)="systemVariablesChanged($event)" (onchangeinput)="systemVariablesNameChanged($event)"
            [recountSelectedRow]="recountSelectedSystemVarTable"></app-datatable>
        </div>
        }
      </div>
    </ng-scrollbar>
  </div>
  @if (detailState == PlansDetailsState.VIEW_DETAILS || detailState == PlansDetailsState.SELECT_STEP) {
  <div class="ot-panel" animate.enter="enter-animation">
    <div class="otsc-plans-detail-container">
      <div class="otsc-plans-detail-container_nav" style="border-right: 1px solid #d5d5d5;">
        <div>
          <button (click)="goBackToPlanDetails()" aria-label="Back" i18n-title title="Back"
            style="margin-right: 10px;padding: 0px;" class="otsc-btn__back ot-btn ot-btn--is-micro ot-btn--is-icon-btn">
            <div class="ot-icon ot-icon__action" id="otsc-plans-detail__back_btn">
            </div>
          </button>
        </div>
        <div class="otsc-text__back otsc-plans-detail-container_stepName" i18n></div>
        @if (detailState != PlansDetailsState.SELECT_STEP) {
        <div class="ot-dropdown" (click)="showDeploymentSteps()">
          <button id="otsc-plan-details-add-step-btn" title="Add steps" i18n-title role="button"
            class="ot-btn ot-btn--is-transparent" style="min-width: unset;padding: 0px;">
            <i class="ot-add">
            </i>
          </button>
        </div>
        }
      </div>
      <div class="otsc-plans-detail-container_nav">
        @if (detailState == PlansDetailsState.VIEW_DETAILS) {
        <div id="otsc-plan-details-step-title">
          <span><b>{{ currentStep.nickname }}</b></span>
          <span style="padding-left:5px" i18n>details</span>
        </div>
        }
        @if (detailState == PlansDetailsState.SELECT_STEP) {
        <div id="otsc-plan-details-step-title">
          <span i18n>Add steps</span>
        </div>
        }
      </div>
      <div class="otsc-plans-detail-container_content"
        style="border-right: 1px solid #d5d5d5;height: calc(100vh - 206px)">
        <ng-scrollbar>
          <ul class="ot-list" cdkDropList [cdkDropListData]="stepRows" (cdkDropListDropped)="drop($event)"
            style="margin-top:0px">
            @for(row of stepRows; let i = $index;track row){
            <li cdkDrag style="cursor:move;" (click)="i != currentStep.stepNo && switchStep(i)" tabindex="0"
              class="ot-list__item"
              [ngClass]="{'otsc-plans-item_selected': currentStep && row.data.step.stepNo === currentStep.stepNo}">
              <span [title]="row.data.step.nickname">{{row.data.step.nickname}}</span>
            </li>
            }
            @if (stepRows.length == 0) {
            <li>
              <img i18n-alt alt="No deployment step selected." src="./assets/icons/es_list220.svg">
              <span i18n style="padding: 0 20px;" i18n>No deployment step selected.</span>
            </li>
            }
          </ul>
        </ng-scrollbar>
      </div>
      <div class="otsc-plans-item-container_content">
        @if (detailState == PlansDetailsState.VIEW_DETAILS) {
        <ng-scrollbar style="height: calc(100vh - 205px);">
          @if (!isCurrentStepLoading) {
          <div animate.enter="enter-animation">
            <div class="ot-row ot-pt-1 ot-pl-1 ot-pb-0">
              <div class="ot-btn-group ot-pl-0">
                <button id="otsc-plan-details-step-details-save-btn" role="button" title="Save" i18n-title
                  class="ot-btn ot-btn--is-primary" (click)="save(PlanSaveState.SAVE_DETAILS)"
                  [disabled]="formGroup.invalid || buttonPending" i18n>
                  Save
                </button>
                <button id="otsc-plan-details-step-details-revert-btn" role="button" title="Revert" i18n-title
                  class="ot-btn ot-btn--is-secondary" (click)="revertStepDetails()" [disabled]="buttonPending" i18n>
                  Revert
                </button>
                <button id="otsc-plan-details-step-details-dup-btn" role="button" title="Duplicate" i18n-title
                  class="ot-btn ot-btn--is-secondary" (click)="duplicateStep(this.currentStep, this.currentStep.stepNo)"
                  [disabled]="buttonPending" i18n>
                  Duplicate
                </button>
                @if (!currentStep.disabled) {
                <button id="otsc-plan-details-step-details-disable-btn" title="Disable" i18n-title role="button"
                  class="ot-btn ot-btn--is-secondary" (click)="disableStep(this.currentStep, this.currentStep.stepNo)"
                  [disabled]="buttonPending" i18n>
                  Disable
                </button>
                }
                @if (currentStep.disabled) {
                <button id="otsc-plan-details-step-details-enable-btn" title="Enable" i18n-title role="button"
                  class="ot-btn ot-btn--is-secondary" (click)="enableStep(this.currentStep, this.currentStep.stepNo)"
                  [disabled]="buttonPending" i18n>
                  Enable
                </button>
                }
                <button id="otsc-plan-details-step-details-remove-btn" role="button" title="Remove" i18n-title
                  class="ot-btn ot-btn--is-secondary" (click)="removeSteps([this.currentStep])"
                  [disabled]="buttonPending" i18n>
                  Remove
                </button>
              </div>
            </div>
            <div class="ot-row ot-pt-0 ot-pl-1 ot-pr-1">
              <div class="ot-col ot-row__column ot-row__column--is-33">
                <div class="ot-form-control">
                  <label for="otsc-step-desc" class="ot-form-control__label" i18n>
                    Description
                  </label>
                  <textarea [readonly]="true" id="otsc-step-desc" class="ot-textarea"
                    [title]="currentStep.summary">{{currentStep.summary}}</textarea>
                </div>
                <div class="ot-form-control ot-mb-0">
                  <label for="otsc-step-label" class="ot-form-control__label" i18n>
                    Label
                  </label>
                  <input id="otsc-step-label" i18n-placeholder placeholder="Enter label" type="text"
                    class="ot-input ot-input--is-expanded" [(ngModel)]="currentStep.label">
                  <p id="otsc-plans-step-label-inst-text" class="ot-form-control__info-text" i18n>
                    Use this field to provide an alternate name or brief description of the step.
                  </p>
                </div>
              </div>
            </div>
            <app-tabs [identifier]="'step-details-tabs'" (selected)="onSelectedDetailsTabChange($event)"
              [scrollIntoView]="false" [tabs]="currentStepTabs" [color]="TabColor.SECONDARY"
              [selectedIndex]="activeDetailsTab" [useParentWidth]="true"></app-tabs>
            @for (group of currentStep.parameterGroups; track group; let i = $index) {
            <div [hidden]="currentStepTab !== group" class="ot-pt-1">
              @for (p of currentStep.parameters | keyvalue | orderBy:'asc':'order' | filterBy:'group':group; track p;
              let j = $index) {
              @if (p.value.visible && !p.value.sensitive) {
              <div class="ot-row" style="margin-bottom: 0px;" [attr.data-plan-param-name]="p.value.displayName.trim()"
                [attr.data-plan-param-type]="p.value.type" [attr.data-plan-param-group]="group">
                <div class="ot-col ot-row__column" [ngClass]="{'ot-row__column--is-60': p.value.supportsVariable}"
                  style="padding-left: 12px;padding-right:12px">
                  <div class="ot-form-control">
                    <label class="ot-form-control__label"
                      [for]="'step-param-value-' + group + '-' + (i + 1) + '-' + (j + 1)">
                      @if (p.value.required) {
                      <div class="ot-form-control__required-indicator"></div>
                      }
                      {{p.value.displayName}}
                    </label>
                    @if (p.value.type === 'INT') {
                    <input [id]="'step-param-value-' + group + '-' + (i + 1) + '-' + (j + 1)" type="number"
                      style="width: unset" class="ot-input" [(ngModel)]="p.value.value"
                      (ngModelChange)="setVarValFromParam(p.value)">
                    }
                    @if (p.value.type === 'STRING') {
                    <input [id]="'step-param-value-' + group + '-' + (i + 1) + '-' + (j + 1)" type="text"
                      style="width: unset" class="ot-input" [(ngModel)]="p.value.value"
                      (ngModelChange)="setVarValFromParam(p.value)"
                      [readonly]="p.value.readonly || p.value.isSensitiveVariable">
                    }
                    @if (p.value.type === 'TEXTAREA') {
                    <textarea [id]="'step-param-value-' + group + '-' + (i + 1) + '-' + (j + 1)"
                      style="width: unset;min-width: unset;resize: vertical;min-height: 32px;" class="ot-textarea"
                      rows="1" [(ngModel)]="p.value.value" (ngModelChange)="setVarValFromParam(p.value)"
                      [readonly]="p.value.isSensitiveVariable"></textarea>
                    }
                    @if (p.value.type === 'BOOLEAN') {
                    <app-checkbox [identifier]="'step-param-value-' + group + '-' + (i + 1) + '-' + (j + 1)"
                      [(ngModel)]="p.value.value" (ngModelChange)="setVarValFromParam(p.value, currentStep)" i18n-label
                      [label]="p.value.displayName" i18n-arialabel [arialabel]="p.value.displayName">
                    </app-checkbox>
                    }
                    @if (p.value.type === 'LIST') {
                    <div class="ot-select ot-pt-0 ot-pb-0">
                      @if (p.value.data == '') {
                      <select [id]="'step-param-value-' + group + '-' + (i + 1) + '-' + (j + 1)"
                        (change)="validateDependency(currentStep, p.value)" [(ngModel)]="p.value.value"
                        (ngModelChange)="setVarValFromParam(p.value)">
                        @for (option of p.value.defaultListValue; track option) {
                        @if (option.visible) {
                        <option [value]="option.value">
                          {{option.name}}
                        </option>
                        }
                        }
                      </select>
                      }
                      @if (p.value.data !='') {
                      <select (otscInit)="getParameterData(p.value, 'defaultListValue')"
                        [id]="'step-param-value-' + group + '-' + (i + 1) + '-' + (j + 1)" [(ngModel)]="p.value.value"
                        (ngModelChange)="onListSelect(p.value)">
                        @for (option of p.value.defaultListValue; track option) {
                        @if (option.visible) {
                        <option [value]="option.value">
                          {{option.name}}
                        </option>
                        }
                        }
                      </select>
                      }
                    </div>
                    }
                    @if (p.value.type === 'EXT_FILE') {
                    <app-ext-ven-files-typeahead
                      [identifier]="'step-param-value-' + group + '-' + (i + 1) + '-' + (j + 1)"
                      [selectedExtVenderFileName]="getExtVenFileVal(p.value.value)" [constraints]="p.value.constraints"
                      (onSelectFile)="onExtVenFileSelect($event, p.value)"
                      (onDeselectFile)="onExtVenFileDeselect(p.value)"></app-ext-ven-files-typeahead>
                    }
                    @if (p.value.type === 'PRODUCT_FILE') {
                    <app-prod-files-typeahead [identifier]="'step-param-value-' + group + '-' + (i + 1) + '-' + (j + 1)"
                      [selectedProdFileName]="p.value.value && p.value.value.name ? p.value.value.name : p.value.value"
                      [constraints]="p.value.constraints" (onSelectFile)="onProdFileSelect($event, p.value)"
                      (onDeselectFile)="onProdFileDeselect(p.value)"></app-prod-files-typeahead>
                    }
                    @if (p.value.type === 'PRODUCT_VERSION') {
                    <div class="ot-combo-box">
                      <div class="ot-dropdown ot-dropdown--is-active">
                        <div class="ot-form-control">
                          <input [id]="'step-param-value-' + group + '-' + (i + 1) + '-' + (j + 1)" type="text" readonly
                            [(ngModel)]="p.value.value" class="ot-input">
                        </div>
                      </div>
                    </div>
                    }
                    @if (p.value.type === 'OBJECT_LIST') {
                    <app-object-list [identifier]="'step-param-value-' + group + '-' + (i + 1) + '-' + (j + 1)"
                      [objectDefinition]="p.value.objectDefinition" [objectList]="p.value.objectList"
                      (onObjectListChange)="p.value.objectList=$event;"></app-object-list>
                    }
                    @if (p.value.type === 'DOWNLOAD_FILE_MULTI') {
                    <app-download-file-multi [identifier]="'step-param-value-' + group + '-' + (i + 1) + '-' + (j + 1)"
                      [refresh]="forceRefreshComp" [(parameter)]="p.value"
                      [step]="currentStep"></app-download-file-multi>
                    }
                    @if (p.value.type === 'CHECK_LIST') {
                    <div class="ot-form-control ot-mb-0">
                      <div class="ot-checkbox-group">
                        @for (item of p.value.valueList; track item; let ival = $index) {
                        @if (item.visible) {
                        <div class="ot-checkbox-options">
                          <app-checkbox
                            [identifier]="'step-param-value-' + group + '-' + (i + 1) + '-' + (j + 1) + '-' +ival"
                            [(ngModel)]="item.selected" (ngModelChange)="onCheckListChange(p.value)" i18n-label
                            [label]="item.name" i18n-arialabel [arialabel]="item.name" i18n-description
                            [description]="item.description" [checklist]="true" [isvalid]="item.valid"></app-checkbox>
                        </div>
                        }
                        }
                      </div>
                    </div>
                    }
                    <p class="ot-form-control__info-text">
                      {{p.value.description}}
                    </p>
                  </div>
                </div>
                @if (p.value.supportsVariable) {
                <div class="ot-col ot-row__column ot-row__column--is-33">
                  <app-variable-typeahead [identifier]="'step-variable-value-' + (i + 1) + '-' + (j + 1)"
                    [variables]="plan.variables" [type]="p.value.type" [variableName]="p.value.variableName"
                    (enterKeyPressed)="addVariable($event, p.value)"
                    (variableSelected)="setParamValFromVariable($event, p.value)"
                    (newVariableSelected)="addVariable($event, p.value)"
                    (removeVariableBtnClicked)="removeVariable($event, p.value)"></app-variable-typeahead>
                </div>
                }
              </div>
              }
              }
            </div>
            }
          </div>
          } @else {
          <div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
            <div class="ot-progress__outer">
              <div class="ot-progress__meter">
              </div>
            </div>
            <div class="ot-progress__text" i18n>Loading...</div>
          </div>
          }
        </ng-scrollbar>
        }
        @if (detailState == PlansDetailsState.SELECT_STEP) {
        <div class="step-table-container">
          <app-datatable [title]="stepListTableTitle" [identifier]="'otsc-plans-details-steplist-table'"
            [showcheckboxes]="true" [rowDensity]="stepRowDensity" [cols]="deploymentStepCols"
            [rows]="deploymentStepRows" (actionmenuevent)="deploymentStepActionMenuClicked($event)"
            (onclickcolumn)="sortStepList($event)" [recountSelectedRow]="recountSelectedRow"></app-datatable>
        </div>
        }
      </div>
    </div>
  </div>
  }
</div>
} @else {
<div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
  <div class="ot-progress__outer">
    <div class="ot-progress__meter">
    </div>
  </div>
  <div class="ot-progress__text" i18n>Loading...</div>
</div>
}